<div class="card-bg rounded-2xl overflow-hidden border border-slate-200 dark:border-white/10 shadow-2xl w-[700px] max-w-full animate-in zoom-in-95 duration-300">
    <!-- Header -->
    <div class="px-6 py-4 border-b border-slate-200 dark:border-white/5 flex items-center justify-between bg-slate-50 dark:bg-white/5">
        <h2 class="text-xl font-bold bg-gradient-to-r from-violet-600 to-indigo-600 dark:from-violet-400 dark:to-indigo-500 bg-clip-text text-transparent">
            {{ data.title }}
        </h2>
        <button (click)="close()" class="text-slate-400 hover:text-slate-600 dark:hover:text-white transition-colors duration-200 p-2 hover:bg-slate-200 dark:hover:bg-white/10 rounded-full">
            <app-icon name="x" [size]="20"></app-icon>
        </button>
    </div>

    <!-- Body -->
    <div class="p-6 max-h-[70vh] overflow-y-auto custom-scrollbar">
        <!-- Metadata Grid -->
        <div class="grid grid-cols-12 gap-4 mb-6">
            @for (field of data.fields; track $index) {
                <div [ngClass]="field.isFullWidth ? 'col-span-12' : 'col-span-12 md:col-span-6'" class="flex flex-col gap-1 p-3 rounded-lg bg-slate-50/50 dark:bg-white/5 border border-slate-100 dark:border-white/5">
                    <span class="text-[10px] uppercase font-bold tracking-widest text-slate-400 dark:text-slate-500">
                        {{ field.label }}
                    </span>
                    <span class="text-sm font-semibold text-slate-800 dark:text-slate-200">
                        {{ field.value ?? '--' }}
                    </span>
                </div>
            }
        </div>

        <!-- Large Content Display (e.g. Prompt Text) -->
        @if (data.highlightValue) {
            <div class="space-y-3">
                <div class="flex items-center justify-between">
                    <span class="text-xs font-bold uppercase tracking-widest text-indigo-500 dark:text-indigo-400">
                        {{ data.highlightLabel || 'Detailed Content' }}
                    </span>
                    <button (click)="copyToClipboard(data.highlightValue)" class="flex items-center gap-1.5 text-[10px] font-bold text-slate-400 hover:text-indigo-500 transition-colors">
                        <app-icon name="copy" [size]="12"></app-icon>
                        COPY ALL
                    </button>
                </div>
                <div class="p-4 rounded-xl bg-slate-100 dark:bg-black/20 border border-slate-200 dark:border-white/5 text-slate-700 dark:text-slate-300 text-sm leading-relaxed whitespace-pre-wrap font-mono">
                    {{ data.highlightValue }}
                </div>
            </div>
        }
    </div>

    <!-- Footer -->
    <div class="px-6 py-4 border-t border-slate-200 dark:border-white/5 flex items-center justify-end bg-slate-50 dark:bg-black/10">
        <app-button variant="primary" (buttonClick)="close()" className="px-8">
            Dismiss
        </app-button>
    </div>
</div>
